import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resolveBackTarget } from '../lib/tabNavigation'; // 단일 소속 사전 (2026-09-07 — 종전 자체 PATH_GROUPS 폐기)
import { probeMark } from '../components/HistoryProbe'; // 계측 빌드에서만 동작(평소 no-op)

// 다른 파일이 이 이름으로 import하던 호환 — 정의는 tabNavigation 하나뿐이다.
export { resolveBackTarget };

export function useBackTo() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return useCallback(() => {
    const historyIndex = typeof window === 'undefined' ? 0 : Number(window.history.state?.idx ?? 0);
    if (historyIndex > 0) {
      probeMark(`backTo nav(-1) from ${pathname}`);
      navigate(-1);
      return;
    }
    probeMark(`backTo root→${resolveBackTarget(pathname)} from ${pathname}`);
    navigate(resolveBackTarget(pathname), { replace: true });
  }, [navigate, pathname]);
}
